import React, { useEffect, useRef } from 'react';
import EditorJS from '@editorjs/editorjs';
// Import any Editor.js tools you need to display images, e.g. ImageTool:
import ImageTool from '@editorjs/image';
import Header from '@editorjs/header';
import Paragraph from '@editorjs/paragraph';
import List from '@editorjs/list';
import Embed from '@editorjs/embed';
import Table from '@editorjs/table';
import Quote from '@editorjs/quote';
import Delimiter from '@editorjs/delimiter';
import Code from '@editorjs/code';
import InlineCode from '@editorjs/inline-code';
import Warning from '@editorjs/warning';
import Checklist from '@editorjs/checklist';

type ReadOnlyEditorProps = {
  data: any;  // Editor.js JSON
  taskId?: string; // Task ID for the comment
  disabled?: boolean;
};

const ReadOnlyEditor: React.FC<ReadOnlyEditorProps> = ({ data, taskId, disabled = false }) => {
  const editorRef = useRef<EditorJS | null>(null);
  const holderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!holderRef.current) return;
    const editor = new EditorJS({
      holder: holderRef.current,
      readOnly: disabled,
      minHeight: 0,
      data,
      tools: {
        header: { class: Header as any, inlineToolbar: true },
        paragraph: { class: Paragraph as any, inlineToolbar: true },
        list: { class: List as any, inlineToolbar: true },
        checklist: { class: Checklist as any, inlineToolbar: true },
        embed: { class: Embed as any, inlineToolbar: true },
        table: { class: Table as any, inlineToolbar: true },
        quote: { class: Quote as any, inlineToolbar: true },
        delimiter: Delimiter as any,
        code: { class: Code as any },
        inlineCode: { class: InlineCode as any },
        warning: { class: Warning as any, inlineToolbar: true },
        image: {
          class: ImageTool as any,
          inlineToolbar: true,
          config: {
            uploader: {
            },
          },
        },
      },
    });

    editorRef.current = editor;

    return () => {
      if (editor && typeof editor.destroy === 'function') {
        editor.destroy();
      }
      editorRef.current = null;
    };
  }, [taskId]);

  return <div ref={holderRef} />;
}
export default ReadOnlyEditor;
